import { useMemo } from 'react';

import { useDisclosure } from '@mantine/hooks';

import { ButtonMantine } from '../../Buttons';
import { CurrencyInput, CurrencyInputProps } from '../../Inputs';
import { Stack } from '../../Layout';
import { useButtonGroupContext } from './ButtonGroup/useButtonGroup';

type BaseCurrencyInputProps = Omit<CurrencyInputProps, 'onClick'>;
interface CustomAmountInputButtonProps extends BaseCurrencyInputProps {
  label?: string;
  onClick?: React.MouseEventHandler<HTMLInputElement>;
  customKey?: string;
}
const CustomAmountInputButton = ({ label, customKey, ...props }: CustomAmountInputButtonProps) => {
  const [opened, handlers] = useDisclosure(false);
  const context = useButtonGroupContext();
  const contextProps = context
    ? {
        onclick: context.onClick,
        value: context.value,
        activeButton: context.activeButton,
      }
    : {};

  const handleClick = () => {
    if (contextProps.onclick) {
      contextProps.onclick({ value: '', label: customKey });
    } else {
      handlers.toggle();
    }
  };

  const isActive = useMemo(() => {
    if (contextProps.activeButton && contextProps.activeButton.label == customKey) {
      return true;
    } else if (opened) {
      return true;
    } else {
      return false;
    }
  }, [contextProps.activeButton, customKey, opened]);

  return (
    <Stack gap="xs">
      <ButtonMantine onClick={handleClick} data-active={isActive}>
        {label ?? 'Other'}
      </ButtonMantine>
      {opened && (
        <CurrencyInput
          label={null}
          allowDecimal={false}
          placeholder="$ 0"
          h={48}
          styles={(theme) => ({
            input: { fontSize: theme.fontSizes.lg, fontWeight: 600, height: 48 },
          })}
          {...props}
        />
      )}
    </Stack>
  );
};

export { CustomAmountInputButton };
